import { render, staticRenderFns } from "./Materiales.vue?vue&type=template&id=3ddd7e07&scoped=true&"
import script from "./Materiales.vue?vue&type=script&lang=js&"
export * from "./Materiales.vue?vue&type=script&lang=js&"
import style0 from "./Materiales.vue?vue&type=style&index=0&id=3ddd7e07&prod&lang=scss&scoped=true&"
import style1 from "./Materiales.vue?vue&type=style&index=1&id=3ddd7e07&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddd7e07",
  null
  
)

export default component.exports